import { onCreateFileExample } from "@/utils/createFile";
import { FunctionComponent } from "react";

interface IDownloadExampleButton {
  fileFormater: string;
  title?: string;
  buttonText?: string;
}

export const DownloadFileButton: FunctionComponent<IDownloadExampleButton> = ({
  fileFormater,
  title = "Arquivo_Exemplo",
  buttonText = "Baixar arquivo exemplo",
}) => {
  const handleDownload = () => {
    onCreateFileExample({
      formater: fileFormater,
      title: title,
    });
  };

  return (
    <button
      type="button"
      onClick={handleDownload}
      className="border border-primary text-primary font-bold rounded-inputs h-[40px] w-full transition-colors duration-200 hover:bg-[#397088] hover:text-white"
    >
      {buttonText}
    </button>
  );
};
